import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const PredictionsList = styled.ul`
  -webkit-padding-start: 0;
  color: var(--color-neutral__body);
  background-color: var(--color-neutral__page-background);
  border-radius: 0 0 var(--input__border-radius) var(--input__border-radius);
  border: solid 1px var(--color-neutral__line);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-inline-start: 0;
  position: absolute;
  top: calc(100% - 1px);
  width: 100%;
  z-index: 100;
`;

export const PredictionsButton = styled.button`
  font-size: 0.75rem;
  outline: none;
  padding: 0.75rem 11px;
  text-align: left;

  &:nth-child(even) {
    background-color: var(--color-neutral__accent-background);
  }

  &:hover {
    background-color: var(--color-neutral__accent-background);
  }

  &:focus {
    border: solid 1px var(--color-primary__regular);
  }
`;

export const Loader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;

  .ant-spin {
    color: var(--color-primary__regular);
  }

  .ant-spin-text {
    color: var(--color-neutral__title-active);
    margin-top: 0.75rem;
  }
`;
